import Link from 'next/link';

import { Link as SanityLink } from '@root/sanity/sanity.types';

type HoverNavProps = {
  navItems: Array<SanityLink>;
};

const HoverNav = ({ navItems }: HoverNavProps) => {
  return (
    <div
      className="
        hover-box
        absolute
        top-80
        hidden
        bg-white
        px-16
        py-8
        shadow-2
        transition-opacity
        duration-200
        ease-linear
        md:invisible
        md:block
        md:origin-top-left
        md:opacity-0
        md:group-hover:visible
        md:group-hover:block
        md:group-hover:opacity-100
      "
    >
      {navItems.map((item) => {
        return (
          <Link
            href={item.href}
            key={item.title}
            className={`block px-8 py-8 text-sm text-gray-darker md:hover:underline ${
              item.trackerClass ? item.trackerClass.replace('sub_nav', 'hover_nav') : ''
            }`}
          >
            {item.title}
          </Link>
        );
      })}
    </div>
  );
};

export default HoverNav;
